/* esm.sh - applesauce-core@5.2.0/dist/models/base */
export * from "/*applesauce-core@5.2.0/esnext/dist/models/base.mjs";
